import React from "react";
import ReactLoading from "react-loading";
import PropTypes from "prop-types";
import { GREEN_LIGHT } from "../../../styles/shared/colors";

const Loader = ({ type, color, delay, height, width, className }) => (
  <ReactLoading
    type={type}
    color={color}
    delay={delay}
    height={height}
    width={width}
    className={className}
  />
);

Loader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  delay: PropTypes.number,
  height: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string
};

Loader.defaultProps = {
  className: null,
  color: GREEN_LIGHT,
  delay: 10,
  height: "64px",
  /**  blank,balls,bars,bubbles,cubes,cylon,spin,spinningBubbles,spokes */
  type: "bubbles",
  width: "64px"
};

export default Loader;
